import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { Router } from '@angular/router';
import { FilterCallback } from './../../../shared/base-reporting/models/filter-callback.interface';
import { FilterItem } from './../../../shared/base-reporting/models/filter-item.interface';
import { AccommodationService } from './../../services/accommodation.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { Accommodation } from 'src/app/shared/models/accommodation.model';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  accommodation = new Accommodation();
  viewFlag = false;
  @ViewChild('viewAcc', { static: true }) viewAcc: ElementRef;
  private Data = [] as Array<TableViewItem>;
  tableColumns = [
    'type',
    'name',
    'city',
    'number_of_rooms'
  ];

  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {

      if (this.currentFilterObject.type) {
        return this.currentFilterObject.type.includes(
          row.type
        );
      }
      return true;
    }).filter(row => {
      if (this.currentFilterObject.city) {
        return row.city.toLowerCase().includes(this.currentFilterObject.city.toLowerCase());
      }
      return true;
    })
  }

  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  constructor(private accommodationService: AccommodationService, private router: Router) { }
  currentFilterObject = {} as FilterModel;
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'viewAccommodation',
      class: 'btn',
      iconClasses: 'fa fa-eye'
    },
    {
      type: 'icon',
      slug: 'editAccommodation',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    }
  ];
  ngOnInit() {
    this.fetchData();
  }
  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  fetchData() {
    this.accommodationService.getAccommodations().subscribe(response => {
      console.log(response);

      this.data = response.data.accommodations.map(r => {

        return {
          id: r.id,
          type: r.type,
          name: r.name,
          city: this.transform(r.City.name),
          number_of_rooms: r.RoomTypes.length
        } as TableViewItem;
      });
    });
  }

  transform(input: string) {
    return input.toLowerCase().replace(/_/g, ' ');
  }

  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'type',
      fieldDisplayName: 'Accommodation Type ',
      fieldType: 'select',
      multiple: false,
      hasSelectAll: false,
      defaultValue: null,
      options: [
        { value: null, display: 'Choose Type' },
        { value: 'LOCAL', display: 'Local' },
        { value: 'HOTEL', display: 'Hotel' }
      ]
    },
    {
      fieldName: 'city',
      fieldDisplayName: 'City ',
      fieldType: 'text'
    }
  ];

  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'viewAccommodation':
        this.viewAcc.nativeElement.click();
        this.viewFlag = true;
        this.accommodation = event.on;
        break;
      case 'editAccommodation':
        this.editAccommodation(event.on.id);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  editAccommodation(id) {
    this.router.navigate(['/accommodations/edit/' + id]);
  }

}


interface FilterModel {
  type: string;
  city: string;
}

interface TableViewItem {
  id: number;
  type: string;
  name: string;
  city: string;
  number_of_rooms: number;
}